import { render, staticRenderFns } from "./order-placed.vue?vue&type=template&id=2916321d&scoped=true&"
import script from "./order-placed.vue?vue&type=script&lang=js&"
export * from "./order-placed.vue?vue&type=script&lang=js&"
import style0 from "./order-placed.vue?vue&type=style&index=0&id=2916321d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916321d",
  null
  
)

export default component.exports